import { render, staticRenderFns } from "./HolderInformation.vue?vue&type=template&id=3db93093&"
import script from "./HolderInformation.vue?vue&type=script&lang=js&"
export * from "./HolderInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports